module.exports = __webpack_public_path__ + "static/img/sangwenfeng.f4aaefc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/sangwenfeng.jpg
// module id = dYS8
// module chunks = 0